import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PasswordStrengthValidator } from '../password-strength.validators';
import { LoginService } from 'src/app/_services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/_alert';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.css']
})
export class ResetPassComponent implements OnInit {

  hideNew = true;
  hide = true;
  hideConfirmNew = true;
  submitted = true;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  constructor(public loginService: LoginService,
    public alertService: AlertService,
    public route: ActivatedRoute,
    public router: Router) { }

  ngOnInit(): void {
  }

  resetForm: FormGroup = new FormGroup(
    {
      newPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        PasswordStrengthValidator
      ]),
      confirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        PasswordStrengthValidator
      ])
    })

  resetPassword() {
    this.submitted = true;
    if (this.resetForm.valid) {
      if (this.resetForm.value.newPassword == this.resetForm.value.confirmPassword) {
        this.route.queryParams.subscribe((response) => {
          var token = response.at;
          this.loginService.resetPassword(this.resetForm.value, token).subscribe((response) => {
            console.log(response);
            this.alertService.success('Success!! Password changed successfully. ', this.options);
            setTimeout(() => {
              this.router.navigate(['/signin'])
            }, 2000);
          })
        }, (err) => {
          console.log(err);
          this.alertService.error(err.error.errors.Messages[0], this.options);
        })
      } else {
        console.log("New password and confirm password should be match!");
        this.alertService.error('Error :( New password and confirm password should be match!', this.options)
      }
    }
    else {
      console.log("Please enter valid data!");
      this.alertService.error('Error!! Please Enter valid data.', this.options);
    }
  }

  get forms() {
    return this.resetForm.controls;
  }

}
